export default __webpack_public_path__ + "static/stairs_w.d36ba62fb0792e57b6bfe9b5573f9fde.svg";